import { Link } from '@src/components';
import { Prose } from '@src/components/Prose/Prose';

export function PolicyRu() {
  return (
    <Prose>
      <h1>Политика в отношении обработки персональных данных</h1>

      <span className="prose__meta">Последнее обновление: 29 октября 2026 года</span>

      <h2 id="list-1">1. Общие положения</h2>
      <span>
        Настоящая политика обработки персональных данных составлена в соответствии с требованиями
        Федерального закона от 27.07.2006. №152-ФЗ «О персональных данных» и определяет порядок
        обработки персональных данных и меры по обеспечению безопасности персональных данных{' '}
        <mark>Питько Любови Андреевны</mark> (далее – Оператор).
      </span>
      <ol>
        <li>
          Оператор ставит своей важнейшей целью и условием осуществления своей деятельности
          соблюдение прав и свобод человека и гражданина при обработке его персональных данных, в
          том числе защиты прав на неприкосновенность частной жизни, личную и семейную тайну.
        </li>
        <li>
          Настоящая политика Оператора в отношении обработки персональных данных (далее – Политика)
          применяется ко всей информации, которую Оператор может получить о посетителях веб-сайта{' '}
          <mark>https://santa-secret.ru</mark>.
        </li>
      </ol>

      <h2 id="list-2">2. Основные понятия, используемые в Политике</h2>

      <ol>
        <li>
          Автоматизированная обработка персональных данных – обработка персональных данных с помощью
          средств вычислительной техники;
        </li>
        <li>
          Блокирование персональных данных – временное прекращение обработки персональных данных (за
          исключением случаев, если обработка необходима для уточнения персональных данных);
        </li>
        <li>
          Веб-сайт – совокупность графических и информационных материалов, а также программ для ЭВМ
          и баз данных, обеспечивающих их доступность в сети интернет по сетевому адресу{' '}
          <mark>https://santa-secret.ru</mark>;
        </li>
        <li>
          Информационная система персональных данных — совокупность содержащихся в базах данных
          персональных данных, и обеспечивающих их обработку информационных технологий и технических
          средств;
        </li>
        <li>
          Обезличивание персональных данных — действия, в результате которых невозможно определить
          без использования дополнительной информации принадлежность персональных данных конкретному
          Пользователю или иному субъекту персональных данных;
        </li>
        <li>
          Обработка персональных данных – любое действие (операция) или совокупность действий
          (операций), совершаемых с использованием средств автоматизации или без использования таких
          средств с персональными данными, включая сбор, запись, систематизацию, накопление,
          хранение, уточнение (обновление, изменение), извлечение, использование, передачу
          (распространение, предоставление, доступ), обезличивание, блокирование, удаление,
          уничтожение персональных данных;
        </li>
        <li>
          Оператор – государственный орган, муниципальный орган, юридическое или физическое лицо,
          самостоятельно или совместно с другими лицами организующие и (или) осуществляющие
          обработку персональных данных, а также определяющие цели обработки персональных данных,
          состав персональных данных, подлежащих обработке, действия (операции), совершаемые с
          персональными данными;
        </li>
        <li>
          Персональные данные – любая информация, относящаяся прямо или косвенно к определенному или
          определяемому Пользователю веб-сайта <mark>https://santa-secret.ru</mark>;
        </li>
        <li>
          Пользователь – любой посетитель веб-сайта <mark>https://santa-secret.ru</mark>;
        </li>
        <li>
          Коробка – виртуальная "коробка" для игры в Тайного Санту на сайте{' '}
          <mark>https://santa-secret.ru</mark>;
        </li>
        <li>Организатор – Пользователь, создавший "Коробку";</li>
        <li>
          Участник – Пользователь, принимающий участие в игре "Тайный Санта" в определенной Коробке.
        </li>
        <li>
          Тайный Санта – Участник получивший уведомление о том, кому необходимо дарить подарок; У
          каждого Участника есть свой Тайный Санта.
        </li>
        <li>
          Предоставление персональных данных – действия, направленные на раскрытие персональных
          данных определенному лицу или определенному кругу лиц;
        </li>
        <li>
          Распространение персональных данных – любые действия, направленные на раскрытие
          персональных данных неопределенному кругу лиц (передача персональных данных) или на
          ознакомление с персональными данными неограниченного круга лиц, в том числе обнародование
          персональных данных в средствах массовой информации, размещение в
          информационно-телекоммуникационных сетях или предоставление доступа к персональным данным
          каким-либо иным способом;
        </li>
        <li>
          Трансграничная передача персональных данных – передача персональных данных на территорию
          иностранного государства органу власти иностранного государства, иностранному физическому
          или иностранному юридическому лицу;
        </li>
        <li>
          Уничтожение персональных данных – любые действия, в результате которых персональные данные
          уничтожаются безвозвратно с невозможностью дальнейшего восстановления содержания
          персональных данных в информационной системе персональных данных и (или) результате
          которых уничтожаются материальные носители персональных данных.
        </li>
      </ol>

      <h2 id="list-3">3. Оператор может обрабатывать следующие персональные данные Пользователя</h2>
      <ol>
        <li>
          <mark>Электронный адрес;</mark>
        </li>
        <li>
          <mark>Фамилия, имя, отчество;</mark>
        </li>
        <li>
          <mark>Почтовый адрес (индекс, город, улица);</mark>
        </li>
        <li>
          <mark>Номер телефона;</mark>
        </li>
        <li>
          Также на сайте происходит сбор и обработка обезличенных данных о посетителях (в т.ч.
          файлов «cookie») с помощью сервисов интернет-статистики Яндекс Метрика.
        </li>
        <li>
          Вышеперечисленные данные далее по тексту Политики объединены общим понятием Персональные
          данные.
        </li>
      </ol>

      <h2 id="list-4">4. Цели обработки персональных данных</h2>
      <ol>
        <li>
          Цель обработки персональных данных Пользователя —{' '}
          <mark>
            информирование Пользователя о событиях, связанных с его аккаунтом посредством отправки
            электронных писем и/или уведомлений Вконтакте и/или телеграм; предоставление доступа
            Пользователю к сервисам, информации и/или материалам, содержащимся на веб-сайте.
            Возможность отправки посылки-подарка Участнику на его физический почтовый адрес другим
            Участником.
          </mark>
        </li>
        <li>
          Пользователь всегда может отказаться от получения информационных сообщений, направив
          Оператору письмо на адрес электронной почты <mark>postman@santa-secret.ru</mark> с
          пометкой «Отказ от уведомлений».
        </li>
        <li>
          Обезличенные данные Пользователей, собираемые с помощью сервисов интернет-статистики,
          служат для сбора информации о действиях Пользователей на сайте, улучшения качества сайта и
          его содержания.
        </li>
      </ol>

      <h2 id="list-5">5. Правовые основания обработки персональных данных</h2>
      <ol>
        <li>
          Оператор получает персональные данные непосредственно от Пользователя при их заполнении
          и/или отправке через специальные формы, расположенные на сайте{' '}
          <mark>https://santa-secret.ru</mark>, либо от Организатора, который указывает электронные
          адреса приглашенных лиц для организации игры.
        </li>
        <li>
          Указывая на сайте электронный адрес другого лица, Организатор подтверждает, что до
          передачи адреса Оператору получил от этого лица разрешение на такую передачу и последующую
          обработку адреса Оператором в целях направления приглашения, сервисных уведомлений и
          обеспечения участия в игре «Тайный Санта». Организатор обязуется по запросу Оператора
          подтвердить наличие такого разрешения.
        </li>
        <li>
          Яндекс Метрика загружается только после получения согласия Пользователя на использование
          аналитических файлов cookie через уведомление на сайте.
        </li>
      </ol>

      <h2 id="list-6">
        6. Порядок сбора, хранения, передачи и других видов обработки персональных данных
      </h2>
      <span>
        Безопасность персональных данных, которые обрабатываются Оператором, обеспечивается путем
        реализации правовых, организационных и технических мер, необходимых для выполнения в полном
        объеме требований действующего законодательства в области защиты персональных данных.
      </span>
      <ol>
        <li>
          Оператор обеспечивает сохранность персональных данных и принимает все возможные меры,
          исключающие доступ к персональным данным неуполномоченных лиц.
        </li>
        <li>
          Персональные данные могут предоставляться участникам игры в объеме, необходимом для работы
          сервиса, а также лицам, привлекаемым Оператором для технического обеспечения работы
          сервиса, в том числе поставщикам инфраструктуры, доставки электронных писем, авторизации и
          аналитики, в объеме, необходимом для выполнения соответствующих функций. Также
          персональные данные могут быть переданы в случаях, связанных с исполнением действующего
          законодательства.
        </li>
        <li>
          В случае выявления неточностей в персональных данных, Пользователь может актуализировать
          их самостоятельно, путем направления Оператору уведомление на адрес электронной почты
          Оператора <mark>postman@santa-secret.ru</mark> с пометкой «Актуализация персональных
          данных».
        </li>
        <li>
          Персональные данные обрабатываются до достижения целей обработки, удаления
          соответствующего аккаунта или игры либо до получения требования о прекращении обработки,
          если более длительное хранение не требуется в соответствии с законодательством.
          Пользователь может в любой момент попросить удалить свои персональные данные, направив
          Оператору уведомление посредством электронной почты на электронный адрес Оператора{' '}
          <mark>postman@santa-secret.ru</mark> с пометкой «Удаление персональных данных».
        </li>
      </ol>

      <h3 id="payments">Оплата Премиума через Т-Банк</h3>
      <p>
        На santa-secret.ru оплата Премиума осуществляется через АО «ТБанк» (Т-Банк). Для проведения
        платежа и формирования чека мы передаём банку email для чека, идентификатор заказа, сумму и
        описание покупки, а также сведения о позиции чека и налогообложении. Платёжные реквизиты
        вводятся на странице банка. Сайт не собирает и не хранит полный номер банковской карты и её
        защитный код.
      </p>
      <p>
        Мы храним email для чека, идентификаторы заказа и платежа, сумму, валюту, статус и время
        операции с привязкой к профилю покупателя, чтобы подтвердить оплату, активировать Премиум,
        оказывать поддержку и вести учёт платежей. Это относится как к гостевым, так и к постоянным
        профилям. Email для чека автоматически не привязывается к аккаунту и не делает гостевой
        профиль постоянным.
      </p>
      <p>
        Эти данные обрабатываются для исполнения договора о покупке Премиума и выполнения применимых
        требований законодательства, включая требования к чекам и учёту. Платёжные записи могут
        сохраняться после удаления аккаунта, если это необходимо для выполнения таких требований или
        разрешения споров по оплате. Банк самостоятельно обрабатывает данные на своей платёжной
        странице и может использовать собственные cookie и хранилище браузера. Подробнее — в{' '}
        <a href="https://www.tbank.ru/apps/privacy/" target="_blank" rel="noreferrer">
          политике конфиденциальности Т-Банка
        </a>
        .
      </p>

      <h2 id="cookies">7. Файлы cookie и хранилище браузера</h2>
      <p>
        Мы используем файлы cookie, чтобы обеспечивать вход в аккаунт, а также localStorage и
        sessionStorage, чтобы запоминать настройки сайта и поддерживать работу основных возможностей
        Тайного Санты. С согласия Пользователя мы также собираем обезличенную статистику с помощью
        Яндекс Метрики. На сайте <mark>santa-secret.ru</mark> используются:
      </p>
      <table className="prose__table">
        <thead>
          <tr>
            <th>Название</th>
            <th>Назначение</th>
            <th>Тип</th>
            <th>Срок хранения</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>jwt</td>
            <td>Файл cookie авторизации, благодаря которому вы остаетесь в аккаунте</td>
            <td>Технически необходимый</td>
            <td>Пока действует сессия авторизации</td>
          </tr>
          <tr>
            <td>cardStep</td>
            <td>
              Возвращает к нужному шагу заполнения карточки участника после входа через сторонний
              сервис
            </td>
            <td>Технически необходимый</td>
            <td>Сессия</td>
          </tr>
          <tr>
            <td>lang</td>
            <td>Запоминает выбранный язык интерфейса</td>
            <td>Настройки</td>
            <td>Сессия</td>
          </tr>
          <tr>
            <td>cookie_agreement</td>
            <td>Запоминает согласие или отказ от аналитических cookie (localStorage)</td>
            <td>Настройки</td>
            <td>До очистки данных сайта</td>
          </tr>
          <tr>
            <td>notice_closed</td>
            <td>Запоминает, что вы закрыли действующее сервисное уведомление (localStorage)</td>
            <td>Настройки</td>
            <td>До перезаписи или очистки данных сайта</td>
          </tr>
          <tr>
            <td>_ym_uid</td>
            <td>Яндекс Метрика &mdash; различает посетителей</td>
            <td>Аналитика (только с согласия)</td>
            <td>Обычно до 1 года</td>
          </tr>
          <tr>
            <td>_ym_isad</td>
            <td>Яндекс Метрика &mdash; определяет наличие блокировщика рекламы</td>
            <td>Аналитика (только с согласия)</td>
            <td>Обычно до 20 часов</td>
          </tr>
          <tr>
            <td>_ym_metrika_enabled</td>
            <td>Яндекс Метрика &mdash; проверяет, что счетчик загружен</td>
            <td>Аналитика (только с согласия)</td>
            <td>Обычно до 1 часа</td>
          </tr>
          <tr>
            <td>profile_wallet</td>
            <td>Cookie: доступ к профилям, открытым в этом браузере, и переключение между ними</td>
            <td>Технически необходимый</td>
            <td>До 90 дней</td>
          </tr>
          <tr>
            <td>santa_theme, santa_season</td>
            <td>localStorage: настройки оформления</td>
            <td>Настройки</td>
            <td>До перезаписи или очистки</td>
          </tr>
          <tr>
            <td>ss:new-box:draft:*; ss:new-box:current</td>
            <td>
              localStorage: черновик игры, введённые имена и настройки, ID профиля и шаг создания;
              sessionStorage: ссылка на текущий черновик для возврата после оплаты
            </td>
            <td>Функциональный</td>
            <td>
              Черновик используется до 24 часов; удаляется при завершении или очистке. Ссылка:
              сессия вкладки
            </td>
          </tr>
          <tr>
            <td>ss:premium:return</td>
            <td>
              sessionStorage: адрес возврата, ID профиля и время для продолжения создания игры или
              возврата на прежнюю страницу после оплаты
            </td>
            <td>Функциональный</td>
            <td>Используется до 24 часов в пределах сессии вкладки</td>
          </tr>
          <tr>
            <td>ss:deferred-theme:*</td>
            <td>
              localStorage: понравившаяся тема Премиума, ID профиля и состояние напоминания для игры
            </td>
            <td>Персонализация / предложение Премиума</td>
            <td>Используется до 7 дней; удаляется после обработки напоминания или очистки</td>
          </tr>
          <tr>
            <td>ss:premium:source; ss:premium:checkout-source</td>
            <td>
              sessionStorage: первая и последняя выбранная возможность Премиума, категория страницы,
              расположение кнопки и время для анализа переходов к оплате
            </td>
            <td>Аналитика</td>
            <td>
              Источник: 30 минут бездействия; снимок оплаты: до 24 часов в пределах сессии вкладки
            </td>
          </tr>
          <tr>
            <td>santa_organizer_view:*; santa_link_invited:*</td>
            <td>
              localStorage: режим организатора и ID карточек, для которых скопированы приглашения
            </td>
            <td>Настройки</td>
            <td>До обновления или очистки</td>
          </tr>
          <tr>
            <td>santa_notification_access_*; santa_card_access_*; qd_organizer_access:*</td>
            <td>
              sessionStorage: временный доступ по уведомлению или ссылке к карточке и управлению
              игрой
            </td>
            <td>Технически необходимый</td>
            <td>Сессия вкладки</td>
          </tr>
          <tr>
            <td>participant_access:*</td>
            <td>
              sessionStorage: новые коды восстановления участника и ссылки доступа для экрана
              подтверждения
            </td>
            <td>Технически необходимый</td>
            <td>До подтверждения и очистки либо завершения сессии вкладки</td>
          </tr>
        </tbody>
      </table>
      <p>
        Для статистики действий на сайте мы также используем собственный экземпляр Umami на
        analytics.santa-secret.ru. Он загружается без предварительного согласия на Яндекс Метрику;
        сама библиотека Umami не использует cookie или хранилище браузера. Отдельно сайт сохраняет
        описанные выше данные атрибуции Премиума.
      </p>
      <p>
        События взаимодействия с Премиумом включают выбранную возможность и кнопку, категорию
        страницы, тему, показанную цену и валюту, категорию устройства, результат оплаты и тип
        профиля: гостевой, постоянный или без входа. В записях атрибуции выше хранятся категории и
        время, а не email, реквизиты карты или коды восстановления. Эта статистика нужна для оценки
        переходов к покупке и не означает отслеживание на чужих сайтах.
      </p>
      <p>
        localStorage может сохраняться после закрытия браузера; sessionStorage относится к вкладке и
        может копироваться в новую вкладку оплаты. Указанные сроки использования означают, как долго
        приложение принимает запись: устаревшие данные могут оставаться до обращения к ним,
        перезаписи или очистки. Удалить cookie и данные сайта можно в настройках браузера. При
        очистке могут потеряться черновики и доступ к гостевому профилю. Заранее сохраните коды
        восстановления или привяжите и подтвердите почту. Время подтверждения сохранения кодов мы
        записываем только после отправки вами этого подтверждения.
      </p>
      <p>
        Яндекс Метрика может использовать и другие технические идентификаторы в зависимости от
        браузера и настроек; актуальный список публикуется в{' '}
        <Link
          variant="inline"
          href="https://yandex.com/support/metrica/ru/general/cookie-usage"
          target="_blank"
        >
          документации Яндекс Метрики
        </Link>
        .
      </p>
      <p>
        На сайте может показываться реклама сторонних систем. Рекламные партнеры могут использовать
        собственные файлы cookie, localStorage, пиксели и браузерные идентификаторы, чтобы
        показывать рекламу, ограничивать частоту показов, оценивать эффективность и бороться с
        недействительным трафиком. Список рекламных партнеров и их технических идентификаторов может
        меняться.
      </p>
      <p>
        Если вы входите на сайт через сторонний сервис &mdash; например, Google, VK или Telegram,
        &mdash; этот сервис может использовать собственные файлы cookie и хранилище браузера во
        время авторизации. Этими технологиями управляет сам сервис.
      </p>
      <p>
        Удалить или заблокировать файлы cookie можно в настройках браузера. Обратите внимание: если
        заблокировать технически необходимые файлы cookie, вход в аккаунт и некоторые возможности
        сайта могут перестать работать.
      </p>

      <h2 id="list-8">8. Обработка данных при отправке и получении подарков</h2>
      <ol>
        <li>
          При использовании функции «Подарить волшебство» сервис «Тайный Санта» обрабатывает информацию, необходимую для отправки, получения и учёта подарков, обмена благодарностями и обеспечения работы соответствующих возможностей.
        </li>
        <li>
          В зависимости от действий пользователя могут обрабатываться следующие данные:
          <ul>
            <li>Идентификаторы отправителя и коробки, из которой отправлен подарок.</li>
            <li>Идентификатор коробки-получателя.</li>
            <li>Отображаемое имя и аватар отправителя.</li>
            <li>Текст пожелания, сопровождающего подарок.</li>
            <li>Выбранные настройки анонимности.</li>
            <li>Идентификаторы участников, взаимодействовавших с полученным подарком.</li>
            <li>Тексты благодарностей и сведения об их отправителях.</li>
            <li>Информация о количестве, статусе и времени отправки и получения подарков.</li>
            <li>Сведения о платежах, необходимые для подтверждения покупки, возвратов и исполнения требований законодательства.</li>
            <li>Информация об использовании декоративной рамки для аватара.</li>
          </ul>
        </li>
        <li>
          Если пользователь отправляет подарок неанонимно, его отображаемое имя и аватар могут быть доступны участникам коробки-получателя. При выборе анонимного режима эта информация не раскрывается получателям.
        </li>
        <li>
          Участники коробки-получателя могут видеть пожелание, сопровождающее подарок, независимо от выбранной отправителем анонимности. Поэтому пользователям не следует включать в пожелания конфиденциальную информацию или персональные данные других лиц без соответствующего правового основания.
        </li>
        <li>
          При отправке благодарности пользователь может выбрать, показывать ли отправителю подарка своё имя. Название коробки не показывается. При выборе анонимного режима имя скрывается от отправителя. Текст благодарности при этом передаётся отправителю подарка.
        </li>
        <li>
          Выбранная анонимность относится к отображению информации другим пользователям и не означает анонимности перед сервисом. Сервис сохраняет необходимые технические сведения об отправителях и получателях для обеспечения работы функции, предотвращения злоупотреблений и выполнения законных обязанностей.
        </li>
        <li>
          При использовании функции дарения сервис может фиксировать просмотры подарков, отправку благодарностей и дальнейшую отправку подарков, включая связь между первоначальным и последующими подарками. Эти сведения используются для функционирования сервиса, анализа использования функции и её улучшения.
        </li>
        <li>
          Информация о цепочках дарения и действиях отдельных участников не публикуется в открытом доступе. Обезличенные и агрегированные статистические данные могут использоваться для аналитики и развития сервиса.
        </li>
        <li>
          Пользователь, отправивший подарок, может добровольно включить отображение специальной декоративной рамки на своём аватаре. Рамка может быть видна другим пользователям в тех разделах сервиса, где отображается аватар. При этом информация о конкретных отправленных подарках и их получателях не раскрывается только на основании наличия такой рамки.
        </li>
        <li>
          Сервис может направлять пользователям сервисные уведомления о полученных подарках и благодарностях с учётом применимых настроек уведомлений. Рекламные сообщения направляются только при наличии необходимых законных оснований, включая согласие получателя, когда оно требуется.
        </li>
        <li>
          Информация, связанная с дарением, хранится в течение сроков, установленных настоящей Политикой для соответствующих категорий данных, с учётом целей обработки и обязанностей, предусмотренных законодательством. По окончании применимых сроков данные удаляются или обезличиваются, если их дальнейшее хранение не требуется по закону.
        </li>
        <li>
          Пользователи могут обращаться к оператору персональных данных по вопросам обработки своих данных, исправления сведений, удаления информации и реализации иных предусмотренных законом прав в порядке, установленном настоящей Политикой.
        </li>
      </ol>

      <h2 id="list-9">9. Заключительные положения</h2>
      <ol>
        <li>
          Пользователь может получить любые разъяснения по интересующим вопросам, касающимся
          обработки его персональных данных, обратившись к Оператору с помощью электронной почты{' '}
          <mark>postman@santa-secret.ru</mark>.
        </li>
        <li>
          В данном документе будут отражены любые изменения политики обработки персональных данных
          Оператором. Политика действует бессрочно до замены ее новой версией.
        </li>
        <li>
          Актуальная версия Политики в свободном доступе расположена в сети Интернет по адресу{' '}
          <mark>https://santa-secret.ru/policy</mark>.
        </li>
      </ol>
    </Prose>
  );
}
